module.exports = __webpack_public_path__ + "assets/throttle-white.62dde5b9.svg";